/* eslint-disable */ import { applicationConfigComponent, attributeSelectionComponent, boundingBoxComponent, childEntityRecipesComponent, composedOfComponent, fitRootPerspectiveCameraComponent, materialSwatchComponent, memoEval, sceneEntityRemoteMaterialOverrideComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { CabinetColor, FuelType, PowderCoatType, RoomShapeType } from '../model/index.js';
export const roomComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withEntity('Room').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$walls', true).withEntity('Room').attach(memoEval((self)=>self.$walls.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(composedOfComponent, '$cornerFillers', true).withEntity('Room').attach(memoEval((self)=>self.$cornerFillers.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withEntity('Room').attach(memoEval(()=>[], ()=>({
            layout: 'tabs',
            distanceDataUnit: 'mm',
            initialGlobalUnit: 'inch',
            availableDimensions: [
                'inch',
                'mm'
            ],
            unitDisplayConfig: {
                mm: {
                    strategy: 'decimal',
                    decimalPlaces: 0
                },
                inch: {
                    strategy: 'decimal',
                    decimalPlaces: 2
                }
            }
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'main', true).withEntity('Room').attach(memoEval((self)=>[
            self.$cameraNear,
            self.$cameraFar,
            self.$cameraMinDistance,
            self.$cameraMaxDistance
        ], ($cameraNear, $cameraFar, $cameraMinDistance, $cameraMaxDistance)=>({
            priority: 1,
            fov: 35,
            near: $cameraNear,
            far: $cameraFar,
            polarAngle: 3 / 8 * Math.PI,
            minPolarAngle: Math.PI / 2 - 1,
            maxPolarAngle: Math.PI / 2,
            azimuthAngle: 0,
            minAzimuthAngle: -3 / 4 * Math.PI,
            maxAzimuthAngle: 3 / 4 * Math.PI,
            minDistance: $cameraMinDistance,
            maxDistance: $cameraMaxDistance,
            fitToBox: true
        }))),
    attachComponent.withComponent(boundingBoxComponent, 'default', true).withEntity('Room').attach(memoEval((self)=>[
            self.$boundingBoxMinX,
            self.$boundingBoxMinY,
            self.$boundingBoxMinZ,
            self.$boundingBoxMaxX,
            self.$boundingBoxMaxY,
            self.$boundingBoxMaxZ
        ], ($boundingBoxMinX, $boundingBoxMinY, $boundingBoxMinZ, $boundingBoxMaxX, $boundingBoxMaxY, $boundingBoxMaxZ)=>({
            minX: $boundingBoxMinX,
            minY: $boundingBoxMinY,
            minZ: $boundingBoxMinZ,
            maxX: $boundingBoxMaxX,
            maxY: $boundingBoxMaxY,
            maxZ: $boundingBoxMaxZ
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'drawer33Door66', true).withEntity('Room').attach(memoEval((self)=>[
            self.$drawer33Door66Recipes
        ], ($drawer33Door66Recipes)=>({
            groupLabel: {
                id: "OYVS6r",
                message: "1/3 Drawer, 2/3 Door Base"
            },
            recipes: $drawer33Door66Recipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'fullDoorBase', true).withEntity('Room').attach(memoEval((self)=>[
            self.$fullDoorBaseRecipes
        ], ($fullDoorBaseRecipes)=>({
            groupLabel: {
                id: "TWbQpz",
                message: "Full Door Base"
            },
            recipes: $fullDoorBaseRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxProfessionalBurner', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxProfessionalBurnerRecipes
        ], ($lynxProfessionalBurnerRecipes)=>({
            groupLabel: {
                id: "CBPZlU",
                message: "Lynx Professional Burners"
            },
            recipes: $lynxProfessionalBurnerRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxProfessionalGrill', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxProfessionalRecipes
        ], ($lynxProfessionalRecipes)=>({
            groupLabel: {
                id: "t6PljS",
                message: "Lynx Professional Grill"
            },
            recipes: $lynxProfessionalRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxSedonaGrill', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxSedonaGrillRecipes
        ], ($lynxSedonaGrillRecipes)=>({
            groupLabel: {
                id: "uVKCRf",
                message: "Lynx Sedona"
            },
            recipes: $lynxSedonaGrillRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxSedonaHood', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxSedonaHoodRecipes
        ], ($lynxSedonaHoodRecipes)=>({
            groupLabel: {
                id: "jBfV/t",
                message: "Lynx Sedona Hood"
            },
            recipes: $lynxSedonaHoodRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxSink', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxSinkRecipes
        ], ($lynxSinkRecipes)=>({
            groupLabel: {
                id: "e1KYKY",
                message: "Lynx Sink"
            },
            recipes: $lynxSinkRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'sedonaBurner', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxSedonaBurnerRecipes
        ], ($lynxSedonaBurnerRecipes)=>({
            groupLabel: {
                id: "uVKCRf",
                message: "Lynx Sedona"
            },
            recipes: $lynxSedonaBurnerRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'lynxEvo', true).withEntity('Room').attach(memoEval((self)=>[
            self.$lynxEvoRecipes
        ], ($lynxEvoRecipes)=>({
            groupLabel: {
                id: "6HAma/",
                message: "EVO Affinity"
            },
            recipes: $lynxEvoRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'sinkBaseCabinets', true).withEntity('Room').attach(memoEval((self)=>[
            self.$sinkBaseCabinetRecipes
        ], ($sinkBaseCabinetRecipes)=>({
            groupLabel: {
                id: "a5xZN7",
                message: "Full Door Sink Base"
            },
            recipes: $sinkBaseCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'otherCookingItems', true).withEntity('Room').attach(memoEval((self)=>[
            self.$otherCookingItemRecipes
        ], ($otherCookingItemRecipes)=>({
            groupLabel: {
                id: "oj7cAa",
                message: "Other Cooking Items"
            },
            recipes: $otherCookingItemRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'threeDrawerBase', true).withEntity('Room').attach(memoEval((self)=>[
            self.$threeDrawerBaseRecipes
        ], ($threeDrawerBaseRecipes)=>({
            groupLabel: {
                id: "YKiEVb",
                message: "3-Drawer Base"
            },
            recipes: $threeDrawerBaseRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'trashPulloutBase', true).withEntity('Room').attach(memoEval((self)=>[
            self.$trashPulloutBaseRecipes
        ], ($trashPulloutBaseRecipes)=>({
            groupLabel: {
                id: "mQ0h2U",
                message: "Trash Pullout Base"
            },
            recipes: $trashPulloutBaseRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'fillers', true).withEntity('Room').attach(memoEval((self)=>[
            self.$fillerRecipes
        ], ($fillerRecipes)=>({
            groupLabel: {
                id: "u6rv5H",
                message: "Fillers"
            },
            recipes: $fillerRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'refrigeration', true).withEntity('Room').attach(memoEval((self)=>[
            self.$refrigerationRecipes
        ], ($refrigerationRecipes)=>({
            groupLabel: {
                id: "cqWjSi",
                message: "Refrigeration"
            },
            recipes: $refrigerationRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'endPanels', true).withEntity('Room').attach(memoEval((self)=>[
            self.$endPanelRecipes
        ], ($endPanelRecipes)=>({
            groupLabel: {
                id: "VVqT3G",
                message: "End Panels"
            },
            recipes: $endPanelRecipes
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'frontPanel', true).withEntity('Room').attach(memoEval((self)=>[
            self.$frontPanelColor,
            self.$frontPanelMetalness,
            self.$frontPanelReflectivity,
            self.$frontPanelClearcoat,
            self.$frontPanelClearcoatRoughness,
            self.$frontPanelRoughness,
            self.$frontPanelRoughnessMapUrl,
            self.$frontPanelNormalMapUrl,
            self.$frontPanelNormalScale,
            self.$frontPanelRepeatX,
            self.$frontPanelRepeatY
        ], ($frontPanelColor, $frontPanelMetalness, $frontPanelReflectivity, $frontPanelClearcoat, $frontPanelClearcoatRoughness, $frontPanelRoughness, $frontPanelRoughnessMapUrl, $frontPanelNormalMapUrl, $frontPanelNormalScale, $frontPanelRepeatX, $frontPanelRepeatY)=>({
            materialsToOverride: [
                'cabinetFrontPanelMaterial'
            ],
            fileUrl: '/models/jms.glb',
            materialName: 'cabinetFrontPanelMaterial',
            color: $frontPanelColor,
            metalness: $frontPanelMetalness,
            reflectivity: $frontPanelReflectivity,
            clearcoat: $frontPanelClearcoat,
            clearcoatRoughness: $frontPanelClearcoatRoughness,
            roughness: $frontPanelRoughness,
            roughnessMapUrl: $frontPanelRoughnessMapUrl,
            normalMapUrl: $frontPanelNormalMapUrl,
            normalScale: $frontPanelNormalScale,
            repeatX: $frontPanelRepeatX,
            repeatY: $frontPanelRepeatY
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'body', true).withEntity('Room').attach(memoEval((self)=>[
            self.$cabinetColor,
            self.$cabinetMetalness,
            self.$cabinetReflectivity,
            self.$cabinetClearcoat,
            self.$cabinetClearcoatRoughness,
            self.$cabinetRoughness,
            self.$cabinetRoughnessMapUrl,
            self.$cabinetNormalMapUrl,
            self.$cabinetNormalScale,
            self.$cabinetRepeatX,
            self.$cabinetRepeatY
        ], ($cabinetColor, $cabinetMetalness, $cabinetReflectivity, $cabinetClearcoat, $cabinetClearcoatRoughness, $cabinetRoughness, $cabinetRoughnessMapUrl, $cabinetNormalMapUrl, $cabinetNormalScale, $cabinetRepeatX, $cabinetRepeatY)=>({
            materialsToOverride: [
                'cabinetBodyMaterial'
            ],
            fileUrl: '/models/jms.glb',
            materialName: 'cabinetFrontPanelMaterial',
            color: $cabinetColor,
            metalness: $cabinetMetalness,
            reflectivity: $cabinetReflectivity,
            clearcoat: $cabinetClearcoat,
            clearcoatRoughness: $cabinetClearcoatRoughness,
            roughness: $cabinetRoughness,
            roughnessMapUrl: $cabinetRoughnessMapUrl,
            normalMapUrl: $cabinetNormalMapUrl,
            normalScale: $cabinetNormalScale,
            repeatX: $cabinetRepeatX,
            repeatY: $cabinetRepeatY
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'shape', true).withEntity('Room').attach(memoEval((self)=>[
            self.shape
        ], (shape)=>({
            value: shape,
            options: [
                {
                    label: 'I Shape',
                    img: '/images/kitchen-types/I.png',
                    value: 'I'
                },
                {
                    label: 'L Shape',
                    img: '/images/kitchen-types/L.png',
                    value: 'L'
                },
                {
                    label: 'U Shape',
                    img: '/images/kitchen-types/U.png',
                    value: 'U'
                }
            ]
        })), (state)=>{
        RoomShapeType.assert(state.value);
        return {
            shape: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'fuelType', true).withEntity('Room').attach(memoEval((self)=>[
            self.fuelType
        ], (fuelType)=>({
            value: fuelType,
            options: [
                {
                    label: 'None',
                    value: 'None'
                },
                {
                    label: 'Natural Gas',
                    value: 'NaturalGas'
                },
                {
                    label: 'Propane',
                    value: 'Propane'
                }
            ]
        })), (state)=>{
        FuelType.assert(state.value);
        return {
            fuelType: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'powderCoatType', true).withEntity('Room').attach(memoEval((self)=>[
            self.powderCoatType
        ], (powderCoatType)=>({
            value: powderCoatType,
            options: [
                {
                    label: 'Anvil - No Powder Coating',
                    value: 'Anvil'
                },
                {
                    label: 'Swatch - Powder Coated Faces',
                    value: 'Swatch'
                },
                {
                    label: 'Pulse - Fully Powder Coated',
                    value: 'Pulse'
                }
            ]
        })), (state)=>{
        PowderCoatType.assert(state.value);
        return {
            powderCoatType: state.value
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'cabinetColor', true).withEntity('Room').attach(memoEval((self)=>[
            self.cabinetColor,
            self.$cabinetColorSwatches
        ], (cabinetColor, $cabinetColorSwatches)=>({
            selectedSwatchKey: cabinetColor,
            swatches: $cabinetColorSwatches
        })), (state)=>{
        CabinetColor.assert(state.selectedSwatchKey);
        return {
            cabinetColor: state.selectedSwatchKey
        };
    })
];

//# sourceMappingURL=room.js.map